import * as AppTypes from './types';
import { defaultInfoModalState } from '../reducer/types';

/**
 * UI
 */

/**
 * @param {boolean} data - responsiveContent view (window width < 768)
 */
export const setResponsiveHeaderView = (data = false) => ({
  type: AppTypes.SET_RESPONSIVE_HEADER_VIEW,
  data
});

/**
 * @param {boolean} data - responsiveContent view (window width < 768)
 */
export const setResponsiveContentView = (data = false) => ({
  type: AppTypes.SET_RESPONSIVE_CONTENT_VIEW,
  data
});

export const toggleInfoModal = (modalData = defaultInfoModalState) => ({
  type: AppTypes.TOGGLE_INFO_MODAL,
  data: modalData
});

export const setDeviceOrientation = ({ orientation }) => ({
  type: AppTypes.SET_DEVICE_ORIENTATION,
  data: {
    orientation
  }
});

export const setBrowserType = ({ isMobile }) => ({
  type: AppTypes.SET_MOBILE_BROWSER,
  data: {
    isMobile
  }
});

export const toggleLoadingModal = visibility => ({
  type: AppTypes.SET_LOADING_MODAL,
  data: visibility
});

/**
 * Profile
 */
export const updateUserProfile = data => ({
  type: AppTypes.UPDATE_USER_PROFILE_REQUEST,
  data
});

export const update2FASettings = (
  type,
  value,
  callback = null,
  verifications = null
) => ({
  type: AppTypes.UPDATE_2FA_SETTINGS_REQUEST,
  data: {
    type,
    value,
    callback,
    verifications
  }
});

export const sendPhoneNumVerificationCode = (value, callback = null) => ({
  type: AppTypes.SEND_PHONE_NUM_VERIF_CODE_REQUEST,
  data: { value, callback }
});

export const sendTotpVerificationCode = (value, callback = null) => ({
  type: AppTypes.SEND_TOTP_VERIF_CODE_REQUEST,
  data: { value, callback }
});

/**
 * Email change
 * @param {} data
 */
export const changeEmail = (email, currentStep, callback) => ({
  type: AppTypes.CHANGE_EMAIL_REQUEST,
  data: {
    email,
    callback,
    currentStep
  }
});

export const verifyEmail = (email, code, currentStep, callback) => ({
  type: AppTypes.VERIFY_EMAIL_CODE_REQUEST,
  data: {
    email,
    code,
    currentStep,
    callback
  }
});

/**
 * Phone number change
 * @param phoneNumber phone number
 * @param callback
 * @returns {{data: *, type: string}}
 * @author jozef.repan
 */
export const changePhoneNumber = (phoneNumber, callback) => ({
  type: AppTypes.CHANGE_PHONE_NUMBER_REQUEST,
  data: {
    phoneNumber,
    callback
  }
});

/**
 * @param phoneNumber - new phone number
 * @param code - the code against which we check
 * @param currentStep - current step in changing process
 * @param callback - an function called after success
 * @returns {{data: *, type: string}}
 * @author jozef.repan
 *
 */
export const verifyPhoneNumber = (
  phoneNumber,
  code,
  currentStep,
  callback
) => ({
  type: AppTypes.VERIFY_PHONE_NUMBER_CODE_REQUEST,
  data: {
    phoneNumber,
    code,
    currentStep,
    callback
  }
});

/**
 * Update user from user object
 * @param {*} user updated user
 */
export const updateUser = user => ({
  type: AppTypes.UPDATE_USER,
  data: user
});

export const updateUserPassword = data => ({
  type: AppTypes.UPDATE_USER_PASSWORD_REQUEST,
  data
});

/**
 * Fetch user data
 */
export const fetchUserData = () => ({
  type: AppTypes.GET_USER_DATA
});

/**
 * KYC
 */
export const fetchKycStatusRequest = () => ({
  type: AppTypes.FETCH_KYC_STATUS_REQUEST
});

export const uploadKycDocument = data => ({
  type: AppTypes.UPLOAD_KYC_DOCUMENT_REQUEST,
  data
});

export const deleteKycDocument = id => ({
  type: AppTypes.DELETE_KYC_DOCUMENT_REQUEST,
  id
});

export const cancelKycVerification = () => ({
  type: AppTypes.CANCEL_KYC_VERIFICATION_REQUEST
});

export const setKycStatus = data => ({
  type: AppTypes.FETCH_KYC_STATUS_SUCCESS,
  data
});
